import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
  Tabs,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { link } from "fs";
import SeriesNav from "../../../components/series-navbar/series-nav";


export default function Series() {
  const { 
    theme, setTheme, 
    activeHref, setActiveHref,
    density, setDensity 
  } = useContext(GlobalContext);
  const { 
    activeSeries, setActiveSeries
  } = useContext(ContentContext);
  const [activeTabId, setActiveTabId] = useState("series");

  
  return (
    <>
      <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", height: "100%"}}>
        <img
          src="/images/ffa/ffa-1.jpg"
          alt="Formula Ford Series"
          width={"100%"}
        />
        <img
          src="/images/ffa/ffa-2.jpg"
          alt="Formula Ford Series"
          width={"100%"}
        />
        <img
          src="/images/ffa/ffa-3.jpg"
          alt="Formula Ford Series"
          width={"100%"}
        />
        <img
          src="/images/ffa/ffa-5.jpg"
          alt="Formula Ford Series"
          width={"100%"}
        />
        <img
          src="/images/ffa/ffa-6.jpg"
          alt="Formula Ford Series"
          width={"100%"}
        />
        <img
          src="/images/ffa/ffa-7.jpg"
          alt="Formula Ford Series"
          width={"100%"}
        />
        {/* <img
          src="/images/ffa/ffa-8.jpg"
          alt="Formula Ford Series"
          width={"100%"}
        /> */}
        <img
          src="/images/ffa/ffa-9.jpg"
          alt="Formula Ford Series"
          width={"100%"}
        />
      </div>
    </>
  );
}